import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IconName } from '@fortawesome/free-brands-svg-icons';
import { CorporateConfig } from 'src/app/corporate.config';
import { HelpersService } from 'src/app/helpers/helpers.service';
import { TenantService } from 'src/app/services/tenant.service';

@Component({
  selector: 'app-footer-account-application-mode',
  templateUrl: './footerAccountApplicationMode.component.html',
  styleUrls: ['./footerAccountApplicationMode.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class FooterAccountApplicationModeComponent implements OnInit {
  data = null;
  domain: string;

  constructor(
    private tenantService: TenantService,
    private helper: HelpersService
  ) {}

  ngOnInit() {
    this.domain = this.helper.getPageContent(CorporateConfig.getCmsDomain);

    this.tenantService.getCmsFooter().subscribe({
      next: (data) => this.data = data,
      error: (err: Error) => console.log('Error getting data from CMS', err.message)
    });
  }

  getIconName(name: string): IconName {
    return name.split(' ').at(-1)?.replace('fa-', '') as IconName;
  }
}
